import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { Flame, Check, X } from "lucide-react";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";

export default function BookingResult({ outcome }) {
  const { t } = useI18n();
  const location = useLocation();
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [reservation, setReservation] = useState(null);

  useEffect(() => {
    if (outcome !== "success") { setStatus("ok"); return; }
    const params = new URLSearchParams(location.search);
    const id = params.get("reservation_id");
    if (!id) { setStatus("error"); return; }
    api.get(`/reservations/confirm/${id}`)
      .then(({ data }) => { setReservation(data); setStatus("ok"); })
      .catch(() => setStatus("error"));
  }, [outcome, location.search]);

  const isSuccess = outcome === "success";

  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="booking-result-page">
      <div className="max-w-lg w-full text-center">
        <div className={`inline-flex h-20 w-20 items-center justify-center border ${isSuccess ? "border-ember text-ember" : "border-red-500/50 text-red-400"} mb-10`}>
          {isSuccess ? <Check size={36} /> : <X size={36} />}
        </div>
        <span className="overline flex items-center justify-center gap-3">
          <span className="divider-gold" />
          {isSuccess ? "Confirmado / Confirmed" : "Cancelado / Cancelled"}
        </span>
        <h1 className="font-display font-light text-4xl md:text-6xl tracking-tight mt-6 text-[#F5F3F0]">
          {isSuccess ? t.booking.success_title : t.booking.cancelled_title}
        </h1>
        <p className="mt-6 text-[#A3A3A3] text-lg leading-relaxed">
          {isSuccess ? t.booking.success_body : t.booking.cancelled_body}
        </p>
        {isSuccess && reservation && (
          <div className="mt-10 border border-white/10 p-6 text-left" data-testid="booking-result-summary">
            <p className="overline mb-3">Detalles</p>
            <p className="text-sm text-[#F5F3F0]">{reservation.name} · {reservation.guests} pax</p>
            <p className="text-sm text-[#F5F3F0]">{reservation.date} · {reservation.time_slot}</p>
            <p className="text-sm text-ember mt-2">USD {reservation.amount_usd.toFixed(2)} · {reservation.payment_status}</p>
            <p className="text-xs text-[#A3A3A3] mt-3">Ref: {reservation.id}</p>
          </div>
        )}
        {status === "error" && (
          <p className="mt-6 text-red-400 text-sm">No pudimos verificar la reserva. Escribinos por WhatsApp.</p>
        )}
        <Link to="/" className="btn-primary mt-12 inline-flex" data-testid="back-home-btn">
          <Flame size={14} /> {t.booking.back_home}
        </Link>
      </div>
    </div>
  );
}
